import React, { useContext } from "react";
import classNames from "classnames";
import GlobalContext from "../../context/global";

const ButtonContinue = ({
  onClick,
  caption,
  id,
  tabIndex = 0,
  disabled,
  className = "col-6",
  dataTestId = "continue-button",
  isLoading = false,
}) => {
  const appData = useContext(GlobalContext);
  const {
    dealerProfile: {
      isCDTT,
      dealerStyle: { primaryColor },
    },
  } = appData;

  return (
    <div className={className}>
      <button
        id={id}
        className={classNames("btn btn-lg w-100 fw-bold", {
          "btn-default btn-continue": primaryColor,
          "btn-primary": !primaryColor,
          "rounded rounded-1 text-uppercase": isCDTT,
        })}
        onClick={onClick}
        tabIndex={tabIndex}
        disabled={disabled}
        data-testid={dataTestId}
      >
        {isLoading ? (
          <img src="assets/img/loading.gif" alt="loading" height={22} />
        ) : (
          caption
        )}
      </button>
    </div>
  );
};

export default ButtonContinue;
